﻿export * from './register.component';